export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-1920w.f84bf9d8.avif";